var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "receipt-preview-wrapper" }, [
    _c(
      "div",
      { class: ["receipt-preview-inner", "paper-size-" + _vm.paperSize] },
      [
        _c("receipt-view", {
          attrs: {
            shop_logo: _vm.receiptReviewInfo.shopLogo,
            shop_name: _vm.receiptReviewInfo.shopName,
            shop_address: _vm.receiptReviewInfo.shopAddress,
            shop_tax_id: _vm.receiptReviewInfo.shopTaxId,
            shop_tax_title: _vm.receiptReviewInfo.shopTaxTitle,
            shop_tel: _vm.receiptReviewInfo.shopTel,
            orders: _vm.receiptReviewInfo.orders,
            total_price: _vm.receiptReviewInfo.totalPrice,
            receipt_info: _vm.receiptReviewInfo.receiptInfo,
            date_time: _vm.receiptReviewInfo.dateTime,
            text_footer: _vm.receiptReviewInfo.textFooter,
            font_size: _vm.fontSize
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mt-5" }, [
      _c(
        "button",
        { staticClass: "btn btn-ligth", on: { click: _vm.onPrint } },
        [
          _c("span", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("apps.pos.button.testprintreceipt")) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "fas fa-print" })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42b90476", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42b90476","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BasePosReceiptPreview.vue
// module id = null
// module chunks = 